module.exports = __webpack_public_path__ + "img/bundles-Custom.62765f40.jpg";